import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'query-string'
import { useLazyQuery } from '@apollo/react-hooks'

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import { usePlanDetails } from '../../../shared/hooks/use-plan-details'
import { planType } from '../../../shared/subscription-constants'
import { signUp } from '../../../../lib/analytics/events'
import { SIGN_UP_SCREENS } from '../../../../constants'
import VOUCHER_WITH_SKU_QUERY from '../../../../../graphql/queries/voucher-with-sku.gql'
import AccountDetailsForm from './account-details-form'
import Step from '../step'
import styles from '../sign-up.css'

const AccountDetails = () => {
  const currentScreen = SIGN_UP_SCREENS.ACCOUNT_DETAILS
  const history = useHistory()
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const { getPlanSkuByType } = usePlanDetails()

  const { voucher, plan } = qs.parse(location.search)
  const planList = Object.values(planType)
  const isInPlanList = planList.includes(plan)

  const [
    validateVoucher,
    { data: voucherData, loading: isValidatingVoucher, error: voucherError }
  ] = useLazyQuery(VOUCHER_WITH_SKU_QUERY)

  useEffect(() => {
    // Ensure page loads at the top when navigating here
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (!isAuthenticated) {
      history.push('/')
      return
    }

    // Redirect to plan intro page if the plan is missing or invalid
    if (!plan || !isInPlanList) {
      history.replace(SIGN_UP_SCREENS.PLAN_INTRO.path)
      return
    }

    // Track signup flow step view (sequence & label)
    signUp.stepViewed(currentScreen.datalayerStepSequence, currentScreen.datalayerStepLabel)

    // Validate voucher if it exists
    if (voucher && plan) {
      const planSku = getPlanSkuByType(plan)
      if (planSku) {
        validateVoucher({
          variables: {
            voucherCode: voucher,
            signupSku: planSku
          }
        })
      }
    }
  }, [isAuthenticated, voucher, plan])

  // Handle voucher validation result
  useEffect(() => {
    if (!isValidatingVoucher && voucherError) {
      // Redirect to plan intro page if voucher is invalid for this plan
      history.replace(SIGN_UP_SCREENS.PLAN_INTRO.path)
    }
  }, [voucherData, isValidatingVoucher, voucherError, voucher])

  return (
    <>
      <div className={styles.topContainer}>
        <Step
          current={currentScreen.step}
          total={currentScreen.totalSteps}
        />
        <div className={styles.header}>A few more details about you</div>
        <div className={styles.subHeader}>
          Almost there!
        </div>
      </div>
      <div className={styles.container}>
        <AccountDetailsForm voucher={voucher} />
      </div>
    </>
  )
}

export default AccountDetails
